/**
 * userWeChat模块接口列表
 */
import $http from '../utils/http'// 导入http中创建的axios实例

const userWeChat = {
  // 检查至少有一人绑定过微信
  checkLeastOnePersonBoundWeChat (params) {
    return $http.post(`${global.API_URL}/sme/userWeChat/checkLeastOnePersonBoundWeChat`, params)
  },
  // 检查当前用户是否已经绑定过微信
  checkCurrentUserIsBindWeChat (id, params) {
    let param = new URLSearchParams()
    param.append(id, params)
    return $http.post(`${global.API_URL}/sme/userWeChat/checkCurrentUserIsBindWeChat`, param)
  },
  // 解除用户的微信绑定
  unbindWeChat (id, params) {
    let param = new URLSearchParams()
    param.append(id, params)
    return $http.post(`${global.API_URL}/sme/userWeChat/unbindWeChat`, param)
  }
};

export default userWeChat



// WEBPACK FOOTER //
// ./src/api/userWeChat.js